<template>
  <div>
    <v-container fluid style="margin: 1px; width: 100%; height: 100%">
      <v-card flat>
        <v-toolbar flat class="zero_padding_toolbar">
          <h3>{{ $t("_issues.issueTitle").toLocaleUpperCase(lang) }}</h3>
          <v-spacer></v-spacer>
          <v-btn small color="success" dark class="mb-2" @click="dialog = true">
            <v-icon small dark left>add_circle_outline</v-icon>
            {{ $t("common.new").toLocaleUpperCase(lang) }}
            {{ $t("_issues.issueTitle").toLocaleUpperCase(lang) }}
          </v-btn>
        </v-toolbar>
        <v-dialog v-model="dialog" max-width="500px" :retain-focus="false">
          <v-card>
            <v-card-title>
              <span class="text-h6">
                {{ $t("_issues.issueTitle").toLocaleUpperCase(lang) }}</span
              >
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-container>
                  <v-row>
                    <v-text-field
                      v-model="categoryName"
                      :rules="[(v) => !!v || $t('_rules.categoryRules')]"
                      label="Şikayet/Öneri Konu Başlığı Ekle"
                      required
                    ></v-text-field>
                  </v-row>
                  <v-row justify="end">
                    <v-btn
                      :disabled="!valid"
                      color="success"
                      @click="save"
                      class="mr-2"
                      style="margin: 10px"
                    >
                      {{ $t("common.save") }}
                    </v-btn>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-data-table
          :headers="headers"
          :items="issueCategories"
          :page="page"
          :pageCount="numberOfPages"
          :items-per-page="itemsPerPage"
          class="elevation-2 striped"
          v-model="selectedRows"
          :footer-props="{
            'items-per-page-text': `${perPageText}`,
          }"
          :loading="loadTable"
          :loading-text="$t('common.loadingText')"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td align="right">
                <v-icon small @click="deleteItem(item)" color="error">
                  mdi-delete
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      tab: null,
      valid: false,
      categoryName: "",
      categoryRules: [(v) => !!v || $t("_rules.categoryRules")],
      dialog: false,
      valid: false,
      snackbar: false,
      snackColor: "",
      snackText: "",
      x: null,
      y: null,
      mode: null,
      timeout: 3000,
      loadTable: true,
    };
  },
  created() {
    // this.filter = JSON.parse(JSON.stringify(this.emptyFilter));
    this.getIssueCategories();
  },
  computed: {
    ...mapGetters({ issueCategories: "issues/issueCategories" }),
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
    headers() {
      return [
        {
          text: this.$t("_issues.issueTitle"),
          sortable: true,
          value: "name",
        },
        {
          text: this.$t("_incident.actions"),
          value: "actions",
          sortable: false,
          align: "right",
          divider: false,
          width: 130,
        },
      ];
    },

    perPageText() {
      if (this.language == "en_US") {
        return "Rows per page:";
      }
      return "Sayfa başına satır:";
    },
  },
  methods: {
    ...mapActions(["issues/getIssueCategories"]),
    ...mapActions({
      deleteIssueCategory: "issues/deleteIssueCategory",
    }),
    async getIssueCategories() {
      await this.$store.dispatch("issues/getIssueCategories");
      this.loadTable = false;
    },
    async deleteItem(item) {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Konu başlığını silmek istediğinizden emin misiniz ?",
          text: "Tekrar geri alamayacaksınız.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          confirmButtonColor: "#ff7674",
          cancelButtonColor: "#41b882",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.deleteIssueCategory({
                issue: item,
              });
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Konu başlığı silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Konu başlığı silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.valid = true;
        try {
          await this.$store.dispatch("issues/addIssueCategory", {
            issueCategoryName: this.categoryName,
          });
          this.categoryName = "";
          this.snackbar = true;
          this.snackColor = "success";
          this.snackText = "Kayıt eklendi";
          this.x = "center";
          this.y = "bottom";
        } catch (e) {
          this.snackbar = true;
          this.snackColor = "error";
          this.snackText = "Kayıt eklenemedi";
          console.log(e);
          this.x = "center";
          this.y = "bottom";
        }
        // this.$emit("confirmed", this.editedItem);
        this.getIssueCategories();
        this.dialog = false;
      }
      this.$refs.form.resetValidation()
    },
  },
  watch: {
    language: function () {
      console.log("lang changed");
      this.getIssueCategories();
    },
  },
};
</script>
<style>
.zero_padding_toolbar .v-toolbar__content {
  padding: 0x !important;
}
</style>